module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/soundsystem-icon-0305d272c7591d6ab0c75a3d0dc64a31.png";